export default __webpack_public_path__ + "static/920-06a10f9fdeed4eb6dc7db7dd9be46b8e.gif";